export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-1/3">
            <a href="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-heading font-bold text-foreground-950 tracking-tight">
                Sugargoo<span className="text-primary-500">Spreadsheet</span>
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
              The most comprehensive independent resource for Sugargoo Spreadsheet — helping international shoppers discover products, compare options, and shop smarter since 2024.
            </p>
          </div>

          <div className="lg:w-1/3">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#categories" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Product Categories</a>
              <a href="#what-is" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">What Is Sugargoo Spreadsheet</a>
              <a href="#features" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Why Choose Us</a>
              <a href="#review" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Sugargoo Review</a>
              <a href="#shipping" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer">Shipping Guide</a>
            </div>
          </div>

          <div className="lg:w-1/3">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">External Resources</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-external-link-line mr-1.5"></i>Sugargoo Spreadsheet Main Site
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-external-link-line mr-1.5"></i>Browse All Products
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} Sugargoo Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400 italic">
            This is an independent educational resource and is not officially affiliated with Sugargoo.
          </p>
        </div>
      </div>
    </footer>
  );
}